import { render, staticRenderFns } from "./UploadContent.vue?vue&type=template&id=21e01cd3&scoped=true&lang=pug&"
import script from "./UploadContent.vue?vue&type=script&lang=ts&"
export * from "./UploadContent.vue?vue&type=script&lang=ts&"
import style0 from "./UploadContent.vue?vue&type=style&index=0&id=21e01cd3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e01cd3",
  null
  
)

export default component.exports